module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("BLUE YODEL 3")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-subtitle1"
  }, [_c('span', [_vm._v("THREE YOUTHS")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three youths on subway. "), _c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("FIRST YOUTH")]), _vm._v(",")]), _vm._v(" the shortest, says a girl has told him she wants him to leave her alone. He is inclined to leave her alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("SECOND YOUTH")])]), _vm._v(": "), _c('i', [_vm._v("Naw. That’s what she")]), _vm._v(" want "), _c('i', [_vm._v("you to do")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("THIRD YOUTH")])]), _vm._v(": "), _c('i', [_vm._v("Can’t do that")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("SECOND YOUTH")])]), _vm._v(": "), _c('i', [_vm._v("You do, she be the first one talking shit on you. “He a fag, I tole him to leave me alone; he leave me")]), _vm._v(" alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('i', [_vm._v("THIRD YOUTH")])]), _vm._v(": "), _c('i', [_vm._v("You can act like you leavin’ her alone. But don’t")]), _vm._v(" do "), _c('i', [_vm._v("it")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aea7c4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter05.vue
// module id = 99
// module chunks = 0